import { Checkbox, Divider } from 'antd';
import { useState } from 'react';

const PlaceFilter = (props) => {

    const CheckboxGroup = Checkbox.Group;
    const plainOptions = ['เสียชีวิตในสถานพยาบาล', 'เสียชีวิตนอกสถานพยาบาล'];
    const defaultCheckedList = ['เสียชีวิตในสถานพยาบาล'];
    
    const [checkedList, setCheckedList] = useState(defaultCheckedList);

    const onChange = list => {
        setCheckedList(list);
    };

    
    props.onChange(checkedList);

    return ( 
        <div>
          <CheckboxGroup style={{ fontSize: '15px' }} options={plainOptions} value={checkedList} onChange={onChange} />
        </div>
      
     );
}
 
export default PlaceFilter;